export default {
  bank_id: null,
  agency: null,
  agency_digit: null,
  account_number: null,
  account_digit: null,
  current_account: false,
  account_kind: 'savings',
  name: null,
  titular_document: '',
  account_is: 'cpf',
}